import { render, staticRenderFns } from "./BreakInDamageDescriptionSubSection.vue?vue&type=template&id=e88be772&scoped=true"
import script from "./BreakInDamageDescriptionSubSection.vue?vue&type=script&lang=ts"
export * from "./BreakInDamageDescriptionSubSection.vue?vue&type=script&lang=ts"
import style0 from "./BreakInDamageDescriptionSubSection.vue?vue&type=style&index=0&id=e88be772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88be772",
  null
  
)

export default component.exports